import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { ReactNode } from "react";
import { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
}

// This doesn't currently support HMR
const PageLayout = ({ showHeader, header, showBreadcrumbs, pageContent, showFooter, footer }: PageLayoutProps) => {
    return (
        <>
            <Typography as="div" className="as-wrapper">
                {showHeader && header}
                <div className="page-holder">
                    {showBreadcrumbs && (
                        <Page as="div" className="pf-breadcrumbs-wrapper">
                            <PageBreadcrumbs />
                        </Page>
                    )}
                    {pageContent}
                </div>
                {showFooter && footer}
            </Typography>
        </>
    );
};

export default PageLayout;
